__turbopack_context__.v({
  "edgeBottom": "edge-fade-module__8vuJ6G__edgeBottom",
  "edgeLeft": "edge-fade-module__8vuJ6G__edgeLeft",
  "edgeRight": "edge-fade-module__8vuJ6G__edgeRight",
  "edgeTop": "edge-fade-module__8vuJ6G__edgeTop",
  "layer": "edge-fade-module__8vuJ6G__layer",
  "layer0": "edge-fade-module__8vuJ6G__layer0",
  "layer1": "edge-fade-module__8vuJ6G__layer1",
  "layer2": "edge-fade-module__8vuJ6G__layer2",
  "layer3": "edge-fade-module__8vuJ6G__layer3",
  "layer4": "edge-fade-module__8vuJ6G__layer4",
  "wash": "edge-fade-module__8vuJ6G__wash",
});
